// extracted by mini-css-extract-plugin
module.exports = {"channelIcon":"_2VTzr","doubleSize":"_31SIt","channelLink":"_2q8dT"};